import { LitElement, html } from 'lit'

class HeroSection extends LitElement {
    // Use open DOM for Tailwind styling
    createRenderRoot() {
        return this
    }

    render() {
        return html`
            <section class="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 overflow-hidden">
                <!-- Background decoration -->
                <div class="absolute inset-0 overflow-hidden">
                    <div class="absolute -top-40 -right-32 w-80 h-80 bg-primary-100 dark:bg-primary-900/20 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
                    <div class="absolute -bottom-40 -left-32 w-80 h-80 bg-blue-100 dark:bg-blue-900/20 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
                    <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-purple-100 dark:bg-purple-900/20 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
                </div>

                <!-- Content -->
                <div class="relative z-10 container-custom text-center">
                    <div class="max-w-5xl mx-auto">
                        <!-- Logo/Brand -->
                        <div class="mb-8">
                            <h1 class="text-6xl md:text-8xl font-bold mb-4">
                                <span class="gradient-text">Jigs</span><span class="text-gray-900 dark:text-white">AI</span>
                            </h1>
                        </div>

                        <!-- Tagline -->
                        <h2 class="text-2xl md:text-4xl font-light text-gray-700 dark:text-gray-300 mb-8 max-w-4xl mx-auto leading-relaxed text-balance">
                            Revolutionize your workflow with 
                            <span class="font-semibold gradient-text">AI-powered task automation</span>
                        </h2>

                        <!-- Description -->
                        <p class="text-lg md:text-xl text-gray-600 dark:text-gray-400 mb-12 max-w-3xl mx-auto leading-relaxed">
                            Transform your productivity with intelligent automation that learns, adapts, and executes tasks seamlessly. 
                            Focus on what matters most while JigsAI handles the rest.
                        </p>

                        <!-- CTA Buttons -->
                        <div class="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
                            <sl-button 
                                variant="primary" 
                                size="large"
                                @click="${this.handleGetStarted}">
                                <sl-icon slot="prefix" library="fa-solid" name="fa-rocket"></sl-icon>
                                Get Started Free
                            </sl-button>
                            
                            <sl-button 
                                variant="default" 
                                size="large"
                                @click="${this.handleWatchDemo}">
                                <sl-icon slot="prefix" library="fa-solid" name="fa-circle-play"></sl-icon>
                                Watch Demo
                            </sl-button>
                        </div>

                        <!-- Features preview -->
                        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
                            <div class="flex flex-col items-center">
                                <div class="w-16 h-16 bg-primary-100 dark:bg-primary-900/30 rounded-2xl flex items-center justify-center mb-4">
                                    <sl-icon library="fa-solid" name="fa-bolt-lightning" class="text-2xl text-primary-600 dark:text-primary-400"></sl-icon>
                                </div>
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Lightning Fast</h3>
                                <p class="text-gray-600 dark:text-gray-400 text-center">Process tasks in seconds, not hours</p>
                            </div>

                            <div class="flex flex-col items-center">
                                <div class="w-16 h-16 bg-primary-100 dark:bg-primary-900/30 rounded-2xl flex items-center justify-center mb-4">
                                    <sl-icon library="fa-solid" name="fa-brain" class="text-2xl text-primary-600 dark:text-primary-400"></sl-icon>
                                </div>
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">AI-Powered</h3>
                                <p class="text-gray-600 dark:text-gray-400 text-center">Advanced machine learning algorithms</p>
                            </div>

                            <div class="flex flex-col items-center">
                                <div class="w-16 h-16 bg-primary-100 dark:bg-primary-900/30 rounded-2xl flex items-center justify-center mb-4">
                                    <sl-icon library="fa-solid" name="fa-shield-check" class="text-2xl text-primary-600 dark:text-primary-400"></sl-icon>
                                </div>
                                <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">Secure</h3>
                                <p class="text-gray-600 dark:text-gray-400 text-center">Enterprise-grade security standards</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Scroll indicator -->
                <div class="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                    <sl-icon library="fa-solid" name="fa-chevron-down" class="text-2xl text-gray-400"></sl-icon>
                </div>
            </section>
        `
    }

    handleGetStarted() {
        // Scroll to features section or handle signup
        document.querySelector('features-section')?.scrollIntoView({ 
            behavior: 'smooth' 
        })
    }

    handleWatchDemo() {
        // Handle demo video or modal
        console.log('Watch demo clicked')
    }
}

customElements.define('hero-section', HeroSection)